// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"20360c84","43":"e7bf72fe","49":"20127c8c","149":"948bec80","323":"e74b395d","346":"498e6052","376":"ca3335e7","380":"24b8cd8a","537":"8f504259","540":"9df4fcf1","641":"d33eaa7d","759":"58ab0dd3","782":"13f86689","785":"bfe872e3","819":"4d7dfa97"}[chunkId] + ".chunk.js";
};